import { Data, Model } from '@singularsystems/neo-core';
import { AxiosPromise } from 'axios';
import { injectable } from 'inversify';
import { AppService, Types } from '../ParticipantsTypes';
import ParticipantGrade from '../Models/ParticipantGrade';
import IDType from 'st-common/Participants/Models/IDType';
import CountryDTO from '../Models/DTOs/CountryDTO';

export interface IParticipantsAppCatalogueApiClient {

    /** 
     * Gets a list of participant grades.
     * @returns List.
     */
    getParticipantGrades(): AxiosPromise<Array<Model.PlainTrackedObject<ParticipantGrade>>>;

    /** 
     * Gets a list of ID types.
     * @returns List of ID types.
     */
    getIDTypes(): AxiosPromise<Array<Model.PlainTrackedObject<IDType>>>;

    /** 
     * Gets a list of countries.
     * @returns List of countries.
     */
    getCountries(): AxiosPromise<Array<Model.PlainTrackedObject<CountryDTO>>>;

    // Client only properties / methods
}

@injectable()
export default class ParticipantsAppCatalogueApiClient extends Data.ApiClientBase implements IParticipantsAppCatalogueApiClient {

    constructor (config = AppService.get(Types.Shared.Config)) {
        super(`${config.ParticipantsApi.ApiPath}/participants-app-catalogue`);
    }

    public getParticipantGrades(): AxiosPromise<Array<Model.PlainTrackedObject<ParticipantGrade>>> {
        return this.axios.get(`${this.apiPath}/participant-grades`);
    }

    public getIDTypes(): AxiosPromise<Array<Model.PlainTrackedObject<IDType>>> {
        return this.axios.get(`${this.apiPath}/id-types`);
    }

    public getCountries(): AxiosPromise<Array<Model.PlainTrackedObject<CountryDTO>>> {
        return this.axios.get(`${this.apiPath}/countries`);
    }

    // Client only properties / methods
}